module.exports = __webpack_public_path__ + "r-v3/img/mic_none.b58919c6.svg";